import React from 'react'
import _ from 'lodash'
import csvParser from 'csvtojson'
import { toast } from 'react-toastify'
import { generateHash } from '../../../../common/utils'

const importLines = (lines, model) => {
  const { batchChange } = model
  lines.forEach((line, i) => {
    _.set(model, line.field, line.text)
  })
  batchChange({ values: model.values })
}

export const importTranslates = (translates, recipeModel, variationsModel) => {
  const recipeLines = []
  const variationsLines = []
  let checksumBunch
  let checksumRecipes

  try {
    translates.forEach((csvLine, i) => {
      if (csvLine.field.startsWith('recipeBunch.')) {
        recipeLines.push({
          ...csvLine,
          field: csvLine.field.replace('recipeBunch.', ''),
        })
      }
      if (csvLine.field.startsWith('recipe.')) {
        variationsLines.push({
          ...csvLine,
          field: csvLine.field.replace('recipe.', ''),
        })
      }
      if (csvLine.field === 'checksumBunch') {
        checksumBunch = csvLine.text
      }
      if (csvLine.field === 'checksumRecipes') {
        checksumRecipes = csvLine.text
      }
    })
  } catch {
    return toast.error('Invalid CSV format', {
      position: toast.POSITION.TOP_RIGHT,
    })
  }

  if(`${generateHash(JSON.stringify(recipeModel.values))}` !== `${checksumBunch}` ||
    `${generateHash(JSON.stringify(variationsModel.values))}` !== `${checksumRecipes}`) {
    toast.error(<div>Recipe was changed since last translates export.<br/>Import is impossible.</div>, {
      position: toast.POSITION.TOP_RIGHT,
    })
  } else {
    importLines(recipeLines, recipeModel)
    importLines(variationsLines, variationsModel)
    recipeLines.length = 0
    variationsLines.length = 0
    toast.success('Translations imported successfully', {
      position: toast.POSITION.TOP_RIGHT,
    })
  }
}

const importCSV = (csvText, recipeModel, variationsModel) => {
  csvParser({ output:'json', delimiter: 'auto' })
    .fromString(csvText)
    .then(result => {
      importTranslates(result, recipeModel, variationsModel)
    }).catch(e => {
      toast.error('Invalid CSV format', {
        position: toast.POSITION.TOP_RIGHT,
      })
    })
}

export default async (file, recipeModel, variationsModel, formEl) => {
  let reader = new FileReader()
  reader.readAsText(file, 'UTF-8')
  reader.onload = function (evt) {
    const csvText = evt.target.result
    importCSV(csvText, recipeModel, variationsModel)
    formEl.current.reset()
  }
}
